export default __webpack_public_path__ + "static/media/enghien17.57adad6a.jpg";